import React from 'react';
import { MapPin, Navigation, Clock, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { LINKS } from '../config/links';

const LocationSection = () => {
  return (
    <section id="localisation" className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Où nous trouver
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Notre Localisation
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Situés au cœur de Bondy, nous sommes facilement accessibles
            en transports ou en voiture.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-xl h-[400px] lg:h-auto">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2621.5!2d2.4811!3d48.9021!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66d8d9d9d9d9d%3A0x0!2s43+Avenue+du+Mar%C3%A9chal+de+Lattre+de+Tassigny%2C+93140+Bondy!5e0!3m2!1sfr!2sfr!4v1609459200000"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '400px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localisation Le Paradis Bondy"
            />
          </div>

          {/* Info Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-10">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Le Paradis – Bondy
            </h3>

            <div className="space-y-6">
              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-amber-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">Adresse</p>
                  <p className="text-gray-600">
                    43 Av. du Maréchal de Lattre de Tassigny<br />
                    93140 Bondy, France
                  </p>
                </div>
              </div>

              {/* Hours */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-amber-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">Horaires</p>
                  <p className="text-gray-600">
                    Ouvert tous les jours<br />
                    Fermeture à 23:30
                  </p>
                </div>
              </div>

              {/* Phone */}
              {LINKS.phone && (
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-amber-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 mb-1">Téléphone</p>
                    <a href={`tel:${LINKS.phone}`} className="text-amber-600 hover:text-amber-700 font-medium transition-colors">
                      {LINKS.phoneDisplay}
                    </a>
                  </div>
                </div>
              )}
            </div>

            {/* CTA Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              {LINKS.directions && (
                <a
                  href={LINKS.directions}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1"
                >
                  <Button className="w-full bg-amber-600 hover:bg-amber-700 text-white py-6 font-semibold">
                    <Navigation className="w-5 h-5 mr-2" />
                    Obtenir l'itinéraire
                  </Button>
                </a>
              )}
              {LINKS.phone && (
                <a href={`tel:${LINKS.phone}`} className="flex-1">
                  <Button variant="outline" className="w-full border-amber-600 text-amber-700 hover:bg-amber-50 py-6 font-semibold">
                    <Phone className="w-5 h-5 mr-2" />
                    Appeler
                  </Button>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
